// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { all_routes } from "../router/all_routes";
// import CollapseHeader from "../../core/common/collapse-header/collapse-header";
// import axiosInstance from "../../API/axiosConfig";
// import webserviceUrl from "../../API/webserviceUrl";
// import useUserData from "../../custom_hooks/useUserData";
// import Table from "../../core/common/dataTable/index";
// import dayjs, { Dayjs } from "dayjs";
// import "react-responsive-modal/styles.css";
// import { Modal } from "react-responsive-modal";
// import { DatePicker, TimePicker } from "antd";
// import { toast } from "react-toastify";
// import { MdDelete, MdEdit } from "react-icons/md";
// import DeleteModal from "../../core/modals/deleteModal";
// import SubunitForm from "./SubunitForm";
// import { McitiImg } from "../../utils/iconLogo";

// const AddSubunits = () => {
//   const { lesson_plan_id } = useParams();
//   const [errors, setErrors] = useState<any>({});
//   const [subUnits, setSubunits] = useState([]);
//   const [open, setOpen] = useState(false);
//   const { employee_id, school_code, course } = useUserData();
//   const [isEditForm, setIsEditForm] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState<any>({});
//   const [isSubmittingForm, setIsSubmittingForm] = useState<boolean>(false);

//   const navigate = useNavigate();
//   const [isUpdate, setIsUpdate] = useState(false);
//   const onOpenModal = () => setOpen(true);
//   const onCloseModal = () => {
//     setOpen(false);
//     setFormData(initialFormData);
//   };

//   const initialFormData = {
//     lesson_plan_id: lesson_plan_id,
//     planned_on: null,
//     start_time: null,
//     end_time: null,
//     subunit_desc: "",
//     description: "",
//     objectives: "",
//     contents: "",
//     venue: "",
//     skill_prereq: "",
//     worksheets: null,
//     assignment: null,
//     tchr_material: null,
//     school_code: school_code ?? "",
//     employee_id: employee_id ?? "",
//     course_id: course?.acdmc_course_id ?? "",
//   };
//   const [formData, setFormData] = useState(initialFormData);

//   useEffect(() => {
//     if (course && Object.keys(course).length > 0) {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         course_id: course.acdmc_course_id ?? "",
//         employee_id: employee_id ?? "",
//         school_code: school_code ?? "",
//         lesson_plan_id: lesson_plan_id ?? "",
//       }));
//     }
//   }, [course]);

//   // console.log(dayjs("13:30:20", "hh:mm:ss").format("hh:mm A"));

//   const validateForm = () => {
//     const newErrors: any = {};

//     if (!formData.subunit_desc.trim())
//       newErrors.subunit_desc = "Title is required";
//     if (!formData.description.trim())
//       newErrors.description = "Description is required";
//     if (!formData.venue.trim()) newErrors.venue = "Venue is required";
//     if (!formData.planned_on) newErrors.planned_on = "Planned date is required";
//     if (!formData.start_time) newErrors.start_time = "Start time is required";
//     if (!formData.end_time) newErrors.end_time = "End time is required";
//     if (!formData.objectives.trim())
//       newErrors.objectives = "Objectives are required";
//     if (!formData.contents.trim()) newErrors.contents = "Contents are required";
//     if (!formData.skill_prereq.trim())
//       newErrors.skill_prereq = "Skill prerequisite is required";
//     if (!formData.worksheets)
//       newErrors.worksheets = "Please upload worksheets file";
//     if (!formData.assignment)
//       newErrors.assignment = "Please upload assignment file";
//     if (!formData.tchr_material)
//       newErrors.tchr_material = "Please upload teacher material file";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const getSubUnits = async () => {
//     try {
//       const resp = await axiosInstance.post(webserviceUrl.get_subunits, {
//         school_code,
//         lesson_plan_id,
//       });
//       // console(resp?.data?.data);
//       setSubunits(resp?.data?.data || []);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleChange = (e: any) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: files[0],
//       }));
//     } else {
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
//     setErrors((prev: any) => ({ ...prev, [name]: "" }));
//   };

//   const handleSubmit = async (e: any) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       setIsSubmittingForm(true);
//       // console("Submitted Data:", formData);
//       const data = new FormData();
//       Object.entries(formData).forEach(([key, value]) => {
//         if (value != null) {
//           // this covers both null and undefined
//           data.append(key, value as string | Blob);
//         }
//       });

//       const resp = await axiosInstance.post(webserviceUrl.add_subUnits, data);
//       // console(resp);
//       if (resp?.data?.success) {
//         toast.success(resp?.data?.message);
//         getSubUnits();
//         onCloseModal();
//         setFormData({
//           lesson_plan_id: lesson_plan_id,
//           planned_on: null,
//           start_time: null,
//           end_time: null,
//           subunit_desc: "",
//           description: "",
//           objectives: "",
//           contents: "",
//           venue: "",
//           skill_prereq: "",
//           worksheets: null,
//           assignment: null,
//           tchr_material: null,
//           school_code: school_code ?? "",
//           employee_id: employee_id ?? "",
//           course_id: course?.acdmc_course_id ?? "",
//         });
//       } else {
//         toast.error(resp?.data?.message);
//       }
//     } catch (error: any) {
//       toast.error(error?.response?.data?.message);
//     }
//   };

//   const updateSubunit = async (e: any) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       setIsSubmittingForm(true);
//       // console("Submitted Data:", formData);
//       const data = new FormData();
//       Object.entries(formData).forEach(([key, value]) => {
//         if (value != null) {
//           // this covers both null and undefined
//           data.append(key, value as string | Blob);
//         }
//       });
//       const resp = await axiosInstance.post(
//         webserviceUrl.update_subunits,
//         data,
//       );
//       // console(resp);
//       if (resp?.data?.success) {
//         toast.success(resp?.data?.message);
//         getSubUnits();
//         setFormData({
//           lesson_plan_id: lesson_plan_id,
//           planned_on: null,
//           start_time: null,
//           end_time: null,
//           subunit_desc: "",
//           description: "",
//           objectives: "",
//           contents: "",
//           venue: "",
//           skill_prereq: "",
//           worksheets: null,
//           assignment: null,
//           tchr_material: null,
//           school_code: school_code ?? "",
//           employee_id: employee_id ?? "",
//           course_id: course?.acdmc_course_id ?? "",
//         });
//         setTimeout(() => {
//           setIsSubmittingForm(false);
//           onCloseModal();
//         }, 500);
//       } else {
//         toast.error(resp?.data?.message);
//       }
//     } catch (error: any) {
//       toast.error(error?.response?.data?.message);
//     }
//   };
//   useEffect(() => {
//     getSubUnits();
//   }, []);

//   const handleEdit = (record: any) => {
//     // console.log(record);
//     const [year, month, date] = record.planned_on.split("-");
//     setFormData({ ...record, school_code });
//     onOpenModal();
//   };

//   const handleDelete = async () => {
//     const record = selectedRecord;
//     // return
//     try {
//       const resp = await axiosInstance.post(webserviceUrl.delete_subunit, {
//         school_code,
//         unit_lsnpln_id: record?.unit_lsnpln_id,
//         subunit_lsnpln_id: record?.subunit_lsnpln_id,
//       });
//       // console(resp);
//       if (resp?.data?.success) {
//         toast.success(resp?.data?.message);
//         getSubUnits();
//       } else {
//         toast.error(resp?.data?.message);
//       }
//     } catch (error: any) {
//       toast.error(error?.response?.data?.message);
//     }
//   };

//   const columns = [
//     {
//       title: "S.No",
//       dataIndex: "key",
//       render: (text: string, record: any, index: number) => {
//         return <p>{index + 1}</p>;
//       },
//     },
//     { title: "Sub-unit Title", dataIndex: "subunit_desc", key: "subunit_desc" },
//     { title: "Location", dataIndex: "venue", key: "venue" },

//     {
//       title: "Lesson Date",
//       dataIndex: "planned_on",
//       key: "planned_on",
//       render: (text: string) => dayjs(text).format("DD-MM-YYYY"),
//     },
//     {
//       title: "Lecture Start Time",
//       dataIndex: "start_time",
//       key: "start_time",
//       render: (text: string) => dayjs(text, "hh:mm:ss").format("hh:mm A"),
//     },
//     {
//       title: "Lecture End Time",
//       dataIndex: "end_time",
//       key: "end_time",
//       render: (text: string) => dayjs(text, "hh:mm:ss").format("hh:mm A"),
//     },
//     { title: "Description", dataIndex: "description", key: "description" },
//     {
//       title: "Sub-unit Worksheet",
//       dataIndex: "worksheets",
//       render: (text: string) =>
//         text ? (
//           <a
//             href={text}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-info"
//           >
//             View PDF
//           </a>
//         ) : (
//           "-"
//         ),
//     },
//     {
//       title: "Sub-unit Assignment",
//       dataIndex: "assignment",
//       render: (text: string) =>
//         text ? (
//           <a
//             href={text}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-info"
//           >
//             View PDF
//           </a>
//         ) : (
//           "-"
//         ),
//     },
//     {
//       title: "Teacher Material",
//       dataIndex: "tchr_material",
//       render: (text: string) =>
//         text ? (
//           <a
//             href={text}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-info"
//           >
//             View PDF
//           </a>
//         ) : (
//           "-"
//         ),
//     },
//     {
//       title: "Actions",
//       dataIndex: "lesson_plan_id",
//       key: "lesson_plan_id",
//       render: (text: string, record: any) => (
//         <div style={{ display: "flex", gap: "10px" }}>
//           <MdEdit
//             style={{ cursor: "pointer", color: "#007bff" }}
//             onClick={() => {
//               setIsEditForm(true);
//               handleEdit(record);
//             }}
//           />
//           <MdDelete
//             style={{ cursor: "pointer", color: "#dc3545" }}
//             data-bs-toggle="modal"
//             data-bs-target="#delete_modal"
//             onClick={() => setSelectedRecord(record)}
//           />
//         </div>
//       ),
//     },
//   ];

//   return (
//     <>
//       <>
//         {/* Page Wrapper */}
//         {/* /**/}
//         <DeleteModal handleDelete={handleDelete} />

//         <div className="page-wrapper">
//           <div className="content">
//             {/* Breadcrumb */}
//             <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
//               <div className="my-auto mb-2">
//                 <h2 className="mb-1">Lesson Plan Subunits</h2>
//                 <nav>
//                   <ol className="breadcrumb mb-0">
//                     <li className="breadcrumb-item">
//                       <Link to={all_routes.adminDashboard}>
//                         <i className="ti ti-smart-home" />
//                       </Link>
//                     </li>
//                     <li className="breadcrumb-item">Teacher</li>
//                     <li className="breadcrumb-item active" aria-current="page">
//                       Lesson Plan Subunits
//                     </li>
//                   </ol>
//                 </nav>
//               </div>
//               <div className="d-flex gap-2 my-xl-auto right-content align-items-center flex-wrap ">
//                 {/* {open && ( */}
//                 <div className="mb-2">
//                   <Link to={open ? "#" : "/add-lession-plan"}>
//                     <button
//                       className="btn btn-primary d-flex align-items-center"
//                       onClick={() => open && onCloseModal()}
//                     >
//                       <i className="ti ti-arrow-left me-2" />
//                       Back
//                     </button>
//                   </Link>
//                 </div>
//                 {/* )} */}

//                 <div className="mb-2">
//                   <button
//                     className="btn btn-primary d-flex align-items-center"
//                     onClick={() => {
//                       setIsEditForm(false);
//                       onOpenModal();
//                     }}
//                   >
//                     <i className="ti ti-circle-plus me-2" />
//                     Add New Subunit
//                   </button>
//                 </div>
//                 <div className=" head-icons">
//                   <CollapseHeader />
//                 </div>
//               </div>
//             </div>

//             <div className="card ">
//               <div className="card-body p-3 rounded-3">
//                 {open ? (
//                   <SubunitForm
//                     handleSubmit={handleSubmit}
//                     onCloseModal={onCloseModal}
//                     updateSubunit={updateSubunit}
//                     setFormData={setFormData}
//                     handleChange={handleChange}
//                     open={open}
//                     formData={formData}
//                     errors={errors}
//                     setErrors={setErrors}
//                     isEditForm={isEditForm}
//                     isSubmittingForm={isSubmittingForm}
//                   />
//                 ) : (
//                   <div>
//                     <div className="d-flex justify-content-between">
//                       <h5>Subunit Details</h5>
//                     </div>
//                     <Table
//                       columns={columns}
//                       dataSource={subUnits}
//                       Selection={false}
//                     />
//                   </div>
//                 )}
//               </div>
//             </div>
//             {/* /Breadcrumb */}

//             {/* <div className="card">
//               <div className="card-body p-3">
//                 <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
//                   <h5>Lesson Plan</h5>
//                 </div>
//               </div>
//             </div> */}
//           </div>
//           <div className="footer d-smflex d-flex align-items-center justify-content-center border-top bg-white p-3 pb-0 pt-2">
//             <p className="mb-0">
//                Organized by IHFC, IIT 
//               <img
//                 src={McitiImg}
//                 alt="Mciti Logo"
//                 className="ms-2 "
//                 style={{
//                   height: "40px",
//                   width: "40px",
//                   objectFit: "contain",
//                 }}
//               />
//             </p>
//             {/* <p className="mb-0">  © {new Date()?.getFullYear()} IHFC. All rights reserved.</p> */}
//           </div>
//         </div>
//         {/* /Page Wrapper */}
//       </>
//     </>
//   );
// };

// export default AddSubunits;

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import axiosInstance from "../../API/axiosConfig";
import webserviceUrl from "../../API/webserviceUrl";
import useUserData from "../../custom_hooks/useUserData";
import Table from "../../core/common/dataTable/index";
import dayjs, { Dayjs } from "dayjs";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { DatePicker, TimePicker } from "antd";
import { toast } from "react-toastify";
import { MdDelete, MdEdit } from "react-icons/md";
import DeleteModal from "../../core/modals/deleteModal";
import SubunitForm from "./SubunitForm";
import { McitiImg } from "../../utils/iconLogo";

const AddSubunits = () => {
  const { lesson_plan_id } = useParams();
  const [errors, setErrors] = useState<any>({});
  const [subUnits, setSubunits] = useState([]);
  const [open, setOpen] = useState(false);
  const { employee_id, school_code, course } = useUserData();
  const [isEditForm, setIsEditForm] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({});
  const [isSubmittingForm, setIsSubmittingForm] = useState<boolean>(false);

  const navigate = useNavigate();
  const [isUpdate, setIsUpdate] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => {
    setOpen(false);
    setFormData(initialFormData);
  };

  // ---------------------------------------------------------------------
  // Only these fields are actually collected by the visible form
  // (Lesson Sub-unit, Date of Class, Class Start/End Time, Content,
  // Description, Venue Address). Everything else below that / else
  // required by the API payload but NOT on screen is set to "" / null
  // and sent as-is — no validation, no input — until real fields are
  // added for them.
  // ---------------------------------------------------------------------
  const initialFormData = {
    lesson_plan_id: lesson_plan_id,
    subunit_lsnpln_id: null, // only present/used on edit
    planned_on: null,
    start_time: null,
    end_time: null,
    subunit_desc: "",
    description: "",
    contents: "",
    venue: "",

    // Not on screen yet — sent empty/null, no validation.
    skill_outcome: "",
    attvlu_demo: "",
    attvlu_expctd: "",
    tchr_activity: "",
    tchr_evaluation: "",
    critical_thinking: "",
    learner_activity: "",
    teacher_obs: "",
    hdtchr_obs: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const validateForm = () => {
    const newErrors: any = {};

    // ── Fields actually shown on the form — validated ──────────────
    if (!formData.subunit_desc?.trim())
      newErrors.subunit_desc = "Sub-unit name is required";
    if (!formData.description?.trim())
      newErrors.description = "Description is required";
    if (!formData.venue?.trim()) newErrors.venue = "Venue address is required";
    if (!formData.planned_on)
      newErrors.planned_on = "Date of class is required";
    if (!formData.start_time) newErrors.start_time = "Start time is required";
    if (!formData.end_time) newErrors.end_time = "End time is required";
    if (!formData.contents?.trim()) newErrors.contents = "Content is required";

    // ── Fields NOT on the form — validation commented out until real
    //    inputs exist for them. Re-enable as each field gets added.
    // if (!formData.objectives.trim())
    //   newErrors.objectives = "Objectives are required";
    // if (!formData.skill_prereq.trim())
    //   newErrors.skill_prereq = "Skill prerequisite is required";
    // if (!formData.skill_outcome?.trim())
    //   newErrors.skill_outcome = "Skill outcome is required";
    // if (!formData.tchr_activity?.trim())
    //   newErrors.tchr_activity = "Teacher activity is required";
    // if (!formData.tchr_evaluation?.trim())
    //   newErrors.tchr_evaluation = "Teacher evaluation is required";
    // if (!formData.critical_thinking?.trim())
    //   newErrors.critical_thinking = "Critical thinking prompt is required";
    // if (!formData.learner_activity?.trim())
    //   newErrors.learner_activity = "Learner activity is required";
    // if (!formData.worksheets)
    //   newErrors.worksheets = "Please upload worksheets file";
    // if (!formData.assignment)
    //   newErrors.assignment = "Please upload assignment file";
    // if (!formData.tchr_material)
    //   newErrors.tchr_material = "Please upload teacher material file";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getSubUnits = async () => {
    try {
      const resp = await axiosInstance.post(webserviceUrl.get_subunits, {
        school_code,
        lesson_plan_id,
      });
      setSubunits(resp?.data?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e: any) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
    setErrors((prev: any) => ({ ...prev, [name]: "" }));
  };

  // Builds the plain JSON payload sent to add/update — formats
  // planned_on as "YYYY-MM-DD" and strips seconds off the times so
  // they match the "09:30" style in the sample payloads, and drops
  // any keys that aren't relevant for the given action.
  const buildPayload = (isEdit: boolean) => {
    const payload: any = {
      lesson_plan_id: formData.lesson_plan_id,
      planned_on: formData.planned_on
        ? dayjs(formData.planned_on).format("YYYY-MM-DD")
        : null,
      start_time: formData.start_time
        ? dayjs(formData.start_time, ["HH:mm", "hh:mm A", "HH:mm:ss"]).format(
            "HH:mm",
          )
        : null,
      end_time: formData.end_time
        ? dayjs(formData.end_time, ["HH:mm", "hh:mm A", "HH:mm:ss"]).format(
            "HH:mm",
          )
        : null,
      subunit_desc: formData.subunit_desc,
      description: formData.description,
      contents: formData.contents,
      venue: formData.venue,

      // Not collected on screen yet — always sent, always empty/null
      // until real inputs exist.
      skill_outcome: formData.skill_outcome || "",
      attvlu_demo: formData.attvlu_demo || "",
      attvlu_expctd: formData.attvlu_expctd || "",
      tchr_activity: formData.tchr_activity || "",
      tchr_evaluation: formData.tchr_evaluation || "",
      critical_thinking: formData.critical_thinking || "",
      learner_activity: formData.learner_activity || "",
      teacher_obs: formData.teacher_obs || "",
      hdtchr_obs: formData.hdtchr_obs || "",
    };

    if (isEdit) {
      // Edit payload additionally needs the subunit id, no modified_by/on.
      payload.subunit_lsnpln_id = formData.subunit_lsnpln_id;
    } else {
      // Add payload additionally needs who/when it was created.
      payload.modified_by = employee_id ?? "";
      payload.modified_on = dayjs().format("YYYY-MM-DDTHH:mm:ss");
    }

    return payload;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setIsSubmittingForm(true);
      const payload = buildPayload(false);

      const resp = await axiosInstance.post(
        webserviceUrl.add_subUnits,
        payload,
      );
      if (resp?.data?.success) {
        toast.success(resp?.data?.message);
        getSubUnits();
        onCloseModal();
        setFormData(initialFormData);
      } else {
        toast.error(resp?.data?.message);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsSubmittingForm(false);
    }
  };

  const updateSubunit = async (e: any) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setIsSubmittingForm(true);
      const payload = buildPayload(true);

      const resp = await axiosInstance.post(
        webserviceUrl.update_subunits,
        payload,
      );
      if (resp?.data?.success) {
        toast.success(resp?.data?.message);
        getSubUnits();
        setFormData(initialFormData);
        setTimeout(() => {
          setIsSubmittingForm(false);
          onCloseModal();
        }, 500);
      } else {
        toast.error(resp?.data?.message);
        setIsSubmittingForm(false);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      setIsSubmittingForm(false);
    }
  };

  useEffect(() => {
    getSubUnits();
  }, []);

  const handleEdit = (record: any) => {
    setFormData({
      ...initialFormData,
      ...record,
      subunit_lsnpln_id: record?.subunit_lsnpln_id ?? null,
      lesson_plan_id: record?.lesson_plan_id ?? lesson_plan_id,
    });
    onOpenModal();
  };

  const handleDelete = async () => {
    const record = selectedRecord;
    try {
      const resp = await axiosInstance.post(webserviceUrl.delete_subunit, {
        school_code,
        unit_lsnpln_id: record?.unit_lsnpln_id,
        subunit_lsnpln_id: record?.subunit_lsnpln_id,
      });
      if (resp?.data?.success) {
        toast.success(resp?.data?.message);
        getSubUnits();
      } else {
        toast.error(resp?.data?.message);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text: string, record: any, index: number) => {
        return <p>{index + 1}</p>;
      },
    },
    { title: "Sub-unit Title", dataIndex: "subunit_desc", key: "subunit_desc" },
    { title: "Location", dataIndex: "venue", key: "venue" },
    {
      title: "Lesson Date",
      dataIndex: "planned_on",
      key: "planned_on",
      render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Lecture Start Time",
      dataIndex: "start_time",
      key: "start_time",
      render: (text: string) =>
        text ? dayjs(text, "HH:mm:ss").format("hh:mm A") : "-",
    },
    {
      title: "Lecture End Time",
      dataIndex: "end_time",
      key: "end_time",
      render: (text: string) =>
        text ? dayjs(text, "HH:mm:ss").format("hh:mm A") : "-",
    },
    { title: "Content", dataIndex: "contents", key: "contents" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Actions",
      dataIndex: "lesson_plan_id",
      key: "lesson_plan_id",
      render: (text: string, record: any) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <MdEdit
            style={{ cursor: "pointer", color: "#007bff" }}
            onClick={() => {
              setIsEditForm(true);
              handleEdit(record);
            }}
          />
          <MdDelete
            style={{ cursor: "pointer", color: "#dc3545" }}
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            onClick={() => setSelectedRecord(record)}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <>
        <DeleteModal handleDelete={handleDelete} />

        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Lesson Plan Subunits</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Teacher</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Lesson Plan Subunits
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex gap-2 my-xl-auto right-content align-items-center flex-wrap ">
                <div className="mb-2">
                  <Link to={open ? "#" : "/add-lession-plan"}>
                    <button
                      className="btn btn-primary d-flex align-items-center"
                      onClick={() => open && onCloseModal()}
                    >
                      <i className="ti ti-arrow-left me-2" />
                      Back
                    </button>
                  </Link>
                </div>

                <div className="mb-2">
                  <button
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => {
                      setIsEditForm(false);
                      onOpenModal();
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add New Subunit
                  </button>
                </div>
                <div className=" head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>

            <div className="card ">
              <div className="card-body p-3 rounded-3">
                {open ? (
                  <SubunitForm
                    handleSubmit={handleSubmit}
                    onCloseModal={onCloseModal}
                    updateSubunit={updateSubunit}
                    setFormData={setFormData}
                    handleChange={handleChange}
                    open={open}
                    formData={formData}
                    errors={errors}
                    setErrors={setErrors}
                    isEditForm={isEditForm}
                    isSubmittingForm={isSubmittingForm}
                  />
                ) : (
                  <div>
                    <div className="d-flex justify-content-between">
                      <h5>Subunit Details</h5>
                    </div>
                    <Table
                      columns={columns}
                      dataSource={subUnits}
                      Selection={false}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        
        </div>
      </>
    </>
  );
};

export default AddSubunits;
